const formatNumCoin = require("../../../../utils/formatNumCoin");
const formatNumCurrency = require("../../../../utils/formatNumCurrency");
const formatNumFiat = require("../../../../utils/formatNumFiat");

const adminCtor = require("./adminCtor");
const merchantCtor = require("./merchantCtor");

const displayAmountData = ({amount = 0, type, symbol}) => {
  if (!amount && !symbol) return '';

  const valueHandlers = {
    coin: formatNumCoin,
    currency: formatNumCurrency,
    fiat: formatNumFiat
  };

  const valueHandler = type && valueHandlers[type];
  const number = valueHandler ? valueHandler(amount) : amount;

  return [number, symbol].join(' ');
};

const displayAmountTootltipTitle = ({amount = 0, symbol}) => {
  return [amount, symbol].join(' ');
};
const displayAmountTooltipValue = ({amount= 0}) => amount;

const propsNormal = {
  dataHandler: displayAmountData,
  titleHandler: displayAmountTootltipTitle,
  valueHandler: displayAmountTooltipValue,
  hasCustomData: true
};

const displayAmountAdmin = adminCtor(propsNormal);
const displayAmountMerchant = merchantCtor(propsNormal);

module.exports = {displayAmountAdmin, displayAmountMerchant};
